// "Combine with" under a product (sections/om-between-together.liquid): each row has its own
// Add. Add opens the sheet with that product's picture, its colours and its sizes. A colour
// changes the picture, a size is only marked, and the sheet's button alone puts the product in
// the cart; with sizes it waits for one. A product with nothing to choose is added straight from
// its row. After adding, the shop's own cart opens, the same way as after the page's own Add to
// cart (om-between-product.js). Henric, 2026-10-12, sketch variant A.
(() => document.querySelectorAll('[data-om-combine]').forEach(section => {
  const layer = section.querySelector('[data-combine-layer]');
  if (!layer) return;
  // The sheet is fixed to the window and the dimming is laid over the page: at the end of the
  // page nothing around the section can clip them or keep them under the dock.
  document.querySelectorAll('body > [data-combine-layer="' + layer.dataset.combineLayer + '"]').forEach(old => old.remove());
  document.body.append(layer);
  const sheet = layer.querySelector('[data-combine-sheet]'), scrim = layer.querySelector('[data-combine-scrim]');
  const picture = sheet.querySelector('[data-sheet-img]'), name = sheet.querySelector('[data-sheet-name]'), type = sheet.querySelector('[data-sheet-type]');
  const price = sheet.querySelector('[data-sheet-price]'), body = sheet.querySelector('[data-sheet-body]'), go = sheet.querySelector('[data-sheet-add]');
  const sheetStatus = sheet.querySelector('[data-sheet-status]'), rowStatus = section.querySelector('[data-combine-status]');
  const root = section.dataset.root || '/', words = go.dataset;
  let from = null, panel = null, size = null, busy = false;

  // The dimming is page content, placed over what is on screen plus a margin that reaches under
  // Safari's bars; never a fixed layer (see .om-scrim in om-dock.css for why).
  const place = () => {
    const margin = 260, y = scrollY, bottom = Math.min(document.documentElement.scrollHeight, y + innerHeight + margin);
    scrim.style.top = (y - margin) + 'px'; scrim.style.height = (bottom - y + margin) + 'px';
  };
  const follow = () => { if (sheet.hasAttribute('data-open')) place(); };
  addEventListener('scroll', follow, {passive: true}); addEventListener('resize', follow);

  const sizes = () => panel ? [...panel.querySelectorAll('button[data-variant]')] : [];
  // What the button says and whether it can be pressed, and the price of what is chosen.
  function sync() {
    const all = sizes();
    all.forEach(button => button.setAttribute('aria-pressed', String(button === size)));
    const sold = all.length ? all.every(button => button.disabled) : panel.dataset.available !== 'true';
    go.disabled = busy || sold || (all.length > 0 && !size);
    go.textContent = sold ? words.labelSold : all.length && !size ? words.labelSize : words.labelAdd;
    price.textContent = size ? size.dataset.price : panel.dataset.price;
  }
  // A colour is a product of its own: its picture, its price, its sizes. A size that was marked
  // stays marked when the new colour has it too.
  function colour(index) {
    const panels = [...body.querySelectorAll('[data-colour-panel]')], kept = size ? size.textContent : null;
    panel = panels.find(el => el.dataset.colourPanel === String(index)) || panels[0];
    panels.forEach(el => { el.hidden = el !== panel; });
    body.querySelectorAll('button[data-colour]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === panel.dataset.colourPanel)));
    const label = body.querySelector('[data-colour-name]');
    if (label) label.textContent = panel.dataset.name;
    size = kept === null ? null : sizes().find(button => button.textContent === kept && !button.disabled) || null;
    if (panel.dataset.img) picture.src = panel.dataset.img; else picture.removeAttribute('src');
    name.textContent = panel.dataset.design; type.textContent = panel.dataset.type;
    sheetStatus.textContent = '';
    sync();
  }
  function open(item, button) {
    const template = item.querySelector('template[data-combine-template]');
    if (!template) return;
    body.replaceChildren(template.content.cloneNode(true));
    from = button; size = null; busy = false;
    // The other colours' pictures are fetched now, so that a colour changes the picture at once.
    body.querySelectorAll('[data-colour-panel][data-img]').forEach(el => { if (el.dataset.img) new Image().src = el.dataset.img; });
    const first = body.querySelector('[data-colour-panel][data-first]');
    colour(first ? first.dataset.colourPanel : 0);
    place(); scrim.dataset.on = ''; sheet.inert = false; sheet.dataset.open = '';
    document.body.classList.add('om-combine-locked');
    sheet.focus({preventScroll: true});
  }
  // Not while an add is on its way: if the shop refuses it, the sheet is where that is said.
  function close(refocus = true) {
    if (busy || !sheet.hasAttribute('data-open')) return;
    delete sheet.dataset.open; delete scrim.dataset.on; sheet.inert = true;
    document.body.classList.remove('om-combine-locked');
    if (refocus && from) from.focus({preventScroll: true});
  }
  // Into the cart, then the shop's cart as it now is: in Pipeline's drawer (on a phone it grows
  // out of the dock), or the cart page where there is no drawer.
  async function add(id) {
    const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(id), quantity: 1}]})});
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : words.labelSold);
  }
  async function showCart() {
    const drawer = document.querySelector('#drawer-cart');
    try {
      if (!drawer) throw new Error('no cart drawer');
      const cart = await (await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})).json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart}, bubbles: true}));
      if (drawer.classList.contains('drawer--visible')) document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      else drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles: false}));
    } catch { location.assign(root + 'cart'); }
  }
  // The row's button says so for a moment, then its own word again, also after two adds in a row.
  const own = new WeakMap(), back = new WeakMap();
  function done(button) {
    const label = button && button.querySelector('[data-combine-add-label]');
    if (!label) return;
    if (!own.has(button)) own.set(button, label.textContent);
    clearTimeout(back.get(button));
    button.dataset.done = ''; label.textContent = words.labelAdded;
    back.set(button, setTimeout(() => { delete button.dataset.done; label.textContent = own.get(button); }, 2200));
  }

  section.addEventListener('click', async event => {
    const button = event.target.closest('[data-combine-add]');
    if (!button || busy) return;
    const item = button.closest('[data-combine-item]');
    if (!item.dataset.direct) return open(item, button);
    busy = true; button.disabled = true; rowStatus.textContent = '';
    try { await add(item.dataset.direct); done(button); await showCart(); }
    catch (error) { rowStatus.textContent = error.message; }
    busy = false; button.disabled = false;
  });
  layer.addEventListener('click', async event => {
    if (event.target === scrim || event.target.closest('[data-combine-close]')) return close();
    if (busy || !panel) return;
    const swatch = event.target.closest('button[data-colour]');
    if (swatch) return colour(swatch.dataset.colour);
    const chip = event.target.closest('button[data-variant]');
    if (chip) { size = chip; sheetStatus.textContent = ''; return sync(); }
    if (!event.target.closest('[data-sheet-add]') || go.disabled) return;
    const id = size ? size.dataset.variant : panel.dataset.variant;
    if (!id) return;
    busy = true; sync(); sheetStatus.textContent = '';
    try {
      await add(id);
      busy = false; close(false); done(from);
      await showCart();
    } catch (error) { busy = false; sheetStatus.textContent = error.message; sync(); }
  });
  // Escape closes the sheet; Tab stays inside it while it is open.
  document.addEventListener('keydown', event => {
    if (!sheet.hasAttribute('data-open')) return;
    if (event.key === 'Escape') { event.stopPropagation(); return close(); }
    if (event.key !== 'Tab') return;
    const stops = [...sheet.querySelectorAll('button:not([disabled])')].filter(el => el.offsetParent);
    if (!stops.length) return;
    const first = stops[0], last = stops[stops.length - 1], at = document.activeElement;
    if (event.shiftKey && (at === first || at === sheet)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && at === last) { event.preventDefault(); first.focus(); }
  }, true);
  // Back from another page with the sheet as it was left: closed.
  addEventListener('pageshow', event => { if (event.persisted) { busy = false; close(false); } });
}))();
